import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { DubniumDialog } from '../../../../client/theme/d-dialog';
import { deleteFolderRecursive } from '../../api/deleteFolderRecursive';
import { Folder } from '../../db/Folder';
import { LASFile } from '../../db/LASFile';
import type { MediaUnion } from '../../db/MediaUnion';

export const deleteMedia = async (media: MediaUnion) => {
  const message =
    media instanceof Folder
      ? 'Bist du dir sicher, dass du den Ordner löschen möchtest? Alle darin enthaltenen Dateien werden ebenfalls gelöscht!'
      : 'Bist du dir sicher, dass du die Datei löschen möchtest?';
  const shouldDelete = await DubniumDialog.confirm(message);
  if (!shouldDelete) return;
  const result = await _delete(media);
  if (result) {
    await XSnackbar.show('Erfolgreich gelöscht');
  } else {
    await XSnackbar.show('Datei konnte nicht gelöscht werden');
  }
};

async function _delete(media: MediaUnion) {
  if (media instanceof LASFile) return await LASFile.removeFile(media._id)();
  if (media instanceof Folder) return await deleteFolderRecursive(media._id)();
}
